import { render } from "./AppToolbar.vue?vue&type=template&id=4aaa58b6&scoped=true"
import script from "./AppToolbar.vue?vue&type=script&lang=js"
export * from "./AppToolbar.vue?vue&type=script&lang=js"

import "./AppToolbar.vue?vue&type=style&index=0&id=4aaa58b6&scoped=true&lang=scss"
import "./AppToolbar.vue?vue&type=style&index=1&id=4aaa58b6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaa58b6"]])

export default __exports__